/**
 * @external {p-queue~PQueue} https://github.com/sindresorhus/p-queue#api
 */
